import { EventBus } from '@motionelements/core/src/services/event-bus.service.js';

export default (context, inject) => {
  inject('bus', EventBus);
  context.$bus = EventBus;
};
